module.exports = __webpack_public_path__ + "static/media/UNN-removebg-preview.3f96cf99.png";